/**
 * @deprecated Please do not use COLORS directly, use palette instead.
 */
export const COLORS = {
  // Primary
  PURPLE_116: '#4F15D6',
  PURPLE: '#5E19FF',
  PURPLE_040: '#BFA3FF',
  PURPLE_016: '#E5DAFF',
  PURPLE_008: '#F2EDFF',

  MIDNIGHT_BLUE_116: '#0A094C',
  MIDNIGHT_BLUE: '#0C0B5A',
  MIDNIGHT_BLUE_070: '#55548B',
  MIDNIGHT_BLUE_040: '#9E9DBD',
  MIDNIGHT_BLUE_016: '#D8D8E5',
  MIDNIGHT_BLUE_008: '#ECEBF2',

  // Secondary
  YELLOW_120: '#9D5C04',
  YELLOW_116: '#CA9B1E',
  YELLOW: '#F0B824',
  YELLOW_040: '#F9E3A7',
  YELLOW_016: '#FDF4DC',
  YELLOW_008: '#FEF9ED',
  YELLOW_002: '#FFFEFB',
  YELLOW_LIGHT: '#FFD119',

  // Tertiary
  GREEN_120: '#047C3D',
  GREEN_116: '#009B56',
  GREEN: '#00B866',
  GREEN_040: '#99D7BB',
  GREEN_016: '#D6F4E7',
  GREEN_008: '#EBF9F3',
  GREEN_002: '#FAFEFC',

  RED_120: '#D41437',
  RED_116: '#C72A42',
  RED: '#ED324E',
  RED_040: '#F8ADB8',
  RED_016: '#FCDEE3',
  RED_008: '#FEEFF1',
  RED_002: '#FFFBFB',

  DENIM_116: '#004E80',
  DENIM: '#005D98',
  DENIM_040: '#99BED6',
  DENIM_016: '#D6E5EF',
  DENIM_008: '#EBF2F7',
  DENIM_002: '#FAFCFD',

  // Neutral
  GRAY_002: '#FBFAFA',
  GRAY_004: '#F8F7F6',
  GRAY_006: '#F3F1F0',
  GRAY_008: '#EEECEB',
  GRAY_010: '#E9E7E6',
  GRAY_016: '#DBD9D8',
  GRAY_030: '#A5A5A5',

  // Text
  TEXT_DARK: '#1A1B1C',
  TEXT_LIGHT: '#5D6063',

  BLACK: '#000000',
  WHITE: '#FFFFFF',
};

// border, disabled: DS intent facet names, same values as in the DS.
export const palette = {
  action: {
    disabled: COLORS.GRAY_030,
  },
  background: {
    boxLight: COLORS.GRAY_002,
    boxDark: COLORS.GRAY_004,
    boxDarker: COLORS.GRAY_006,
    boxDarkest: COLORS.GRAY_016,
    grayLight: COLORS.GRAY_010,
    antiflashWhite: COLORS.GRAY_006,
    default: COLORS.GRAY_004,
    paper: COLORS.WHITE,
    tooltip: COLORS.MIDNIGHT_BLUE,
    yellowLight: COLORS.YELLOW_LIGHT,
  },
  common: {
    black: COLORS.BLACK,
    white: COLORS.WHITE,
  },
  charts: {
    canary: '#FFA600',
    corn: '#FEDF71',
    creme: '#B38773',
    blue: '#368BC9',
    lightBlue: '#25BCCF',
    indigo: '#3B52D9',
    magenta: '#A83DBA',
    pink: '#EC407A',
    purple: '#7E57C2',
    peach: '#EF5350',
    orchid: '#7E57C2',
    lavender: '#F0D5FF',
    plum: '#570087',
    tomato: '#FF7043',
  },
  default: {
    contrastText: COLORS.WHITE,
    dark: COLORS.TEXT_DARK,
    main: COLORS.TEXT_LIGHT,
  },
  divider: COLORS.GRAY_010,
  error: {
    border: COLORS.RED_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.RED_120,
    disabled: COLORS.RED_016,
    light: COLORS.RED_008,
    main: COLORS.RED,
  },
  info: {
    border: COLORS.DENIM_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.DENIM_116,
    disabled: COLORS.DENIM_016,
    light: COLORS.DENIM_008,
    main: COLORS.DENIM,
  },
  primary: {
    border: COLORS.PURPLE_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.PURPLE_116,
    disabled: COLORS.PURPLE_016,
    light: COLORS.PURPLE_008,
    main: COLORS.PURPLE,
  },
  secondary: {
    border: COLORS.MIDNIGHT_BLUE_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.MIDNIGHT_BLUE_116,
    disabled: COLORS.MIDNIGHT_BLUE_016,
    light: COLORS.MIDNIGHT_BLUE_008,
    main: COLORS.MIDNIGHT_BLUE,
  },
  success: {
    border: COLORS.GREEN_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.GREEN_120,
    disabled: COLORS.GREEN_016,
    light: COLORS.GREEN_008,
    main: COLORS.GREEN,
  },
  text: {
    disabled: COLORS.GRAY_030,
    primary: COLORS.TEXT_DARK,
    secondary: COLORS.TEXT_LIGHT,
  },
  warning: {
    border: COLORS.YELLOW_040,
    contrastText: COLORS.WHITE,
    dark: COLORS.YELLOW_120,
    disabled: COLORS.YELLOW_016,
    light: COLORS.YELLOW_008,
    main: COLORS.YELLOW,
  },
};
